import { Component } from '@verndale/core';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';

class ShareModule extends Component {
  constructor(el: HTMLElement) {
    super(el);
    this.initAnimation();
  }

  setupDefaults() {
    this.dom = {
      statCardNumber: this.el.querySelector<HTMLElement>('.stat-card-number')
    };
  }

  initAnimation() {
    gsap.registerPlugin(ScrollTrigger);

    ScrollTrigger.config({
      autoRefreshEvents: 'visibilitychange, DOMContentLoaded, load, resize'
    });

    setTimeout(() => {
      ScrollTrigger.refresh();
    }, 1000);

    gsap.from(this.dom.statCardNumber, {
      textContent: 0,
      duration: 2,
      snap: { textContent: 1 },
      ease: 'power1.inOut',
      scrollTrigger: {
        trigger: this.el,
        start: 'top bottom'
      }
    });
  }
}

export default ShareModule;
